import { View, styled } from 'tamagui'
import { useAppStore, useServerStore } from '@/store'
import { ChannelHeader } from '../app/channel/ChannelHeader'
import { MessageList } from '../app/message/MessageList'
import { MessageInput } from '../app/message/MessageInput'
import { VoiceChannelView } from '../app/voice/VoiceChannelView'
import { ForumView } from '../app/channel/ForumView'
import { NsfwGate } from '../app/channel/NsfwGate'
import { MemberSidebar } from './MemberSidebar'

const Content = styled(View, {
  flex: 1,
  flexDirection: 'row',
  backgroundColor: '$surface',
  minWidth: 0,
})

const ChannelArea = styled(View, {
  flex: 1,
  flexDirection: 'column',
  minWidth: 0,
})

const MessageArea = styled(View, {
  flex: 1,
  flexDirection: 'column',
  minHeight: 0,
})

const InputArea = styled(View, {
  paddingHorizontal: 16,
  paddingBottom: 16,
})

export function MainContent() {
  const { activeServerId, activeChannelId, memberSidebarOpen, acknowledgedNsfwChannels } = useAppStore()
  const server = useServerStore((s) => activeServerId ? s.servers[activeServerId] : undefined)

  if (!activeServerId || !activeChannelId) {
    return (
      <Content>
        <ChannelArea>
          <View flex={1} alignItems="center" justifyContent="center">
            <View
              // @ts-expect-error -- web-only style
              style={{ fontSize: 48, marginBottom: 16, opacity: 0.3 }}
            >
              ◈
            </View>
          </View>
        </ChannelArea>
      </Content>
    )
  }

  const channel = server?.channels.find(c => c.id === activeChannelId)

  if (!channel) {
    return (
      <Content>
        <ChannelArea>
          <View flex={1} alignItems="center" justifyContent="center" />
        </ChannelArea>
      </Content>
    )
  }

  if (channel.type === 'voice') {
    return (
      <Content>
        <VoiceChannelView channelId={activeChannelId} />
        {memberSidebarOpen && <MemberSidebar />}
      </Content>
    )
  }

  if (channel.type === 'forum') {
    return (
      <Content>
        <ChannelArea>
          <ChannelHeader channel={channel} memberCount={server?.memberCount || 0} />
          <ForumView channelId={activeChannelId} />
        </ChannelArea>
        {memberSidebarOpen && <MemberSidebar />}
      </Content>
    )
  }

  // NSFW gate
  if (channel.nsfw && !acknowledgedNsfwChannels.includes(channel.id)) {
    return (
      <Content>
        <ChannelArea>
          <ChannelHeader channel={channel} memberCount={server?.memberCount || 0} />
          <NsfwGate channelId={activeChannelId} />
        </ChannelArea>
        {memberSidebarOpen && <MemberSidebar />}
      </Content>
    )
  }

  return (
    <Content>
      <ChannelArea>
        <ChannelHeader channel={channel} memberCount={server?.memberCount || 0} />
        <MessageArea>
          <MessageList channelId={activeChannelId} />
        </MessageArea>
        <InputArea>
          <MessageInput channelId={activeChannelId} />
        </InputArea>
      </ChannelArea>
      {memberSidebarOpen && <MemberSidebar />}
    </Content>
  )
}
